module.exports = {
  API_SERVER_URL: 'https://tomcom-api.alphadelivery.uk',
  GA_ID: 'GTM-KFGTTLC',
  STRIPE_PUB_KEY: 'pk_test_51LE5B5SDma4wutATC5WuxAhN7XSYQVUGiYwDP1nPNJt8348Fwz69XQxu6cSLGpJslUphIeyhddjgLjQmWTOD19k900BJ2y3woY',
  // Custom URL scheme the mobile app registers (iOS CFBundleURLSchemes /
  // Android android:scheme) — it is the bundle id, not 'tomcom'.
  APP_SCHEME: 'com.jbi.tomcom.alpha',
  PHOTO_COST: 20,
};
